import { render, staticRenderFns } from "./addFunctionalAuthority.vue?vue&type=template&id=32268386&scoped=true&"
import script from "./addFunctionalAuthority.vue?vue&type=script&lang=ts&"
export * from "./addFunctionalAuthority.vue?vue&type=script&lang=ts&"
import style0 from "./addFunctionalAuthority.vue?vue&type=style&index=0&id=32268386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32268386",
  null
  
)

export default component.exports